<template>
  <div>
    <div class="container" v-if="loaded">
      <div class="row">
        <div class="col-7">
          <h2>Table of Contents</h2>
          <ul id="toc" class="collapsed">
            <li>
              <a href="#introduction"
                ><i class="fas fa-angle-down" style="font-size: 0.8em"></i>
                Introduction</a
              >
            </li>

            <li>
              <a href="#landcover"
                ><i class="fas fa-angle-down" style="font-size: 0.8em"></i> 1.
                Land Cover</a
              >
            </li>
            <li>
              <a href="#waterresources"
                ><i class="fas fa-angle-down" style="font-size: 0.8em"></i> 2.
                Water Resources</a
              >
            </li>
            <li>
              <a href="#swc"
                ><i class="fas fa-angle-down" style="font-size: 0.8em"></i> 3.
                Soil and Water Conservation</a
              >
            </li>
            <li>
              <a href="#atlas"
                ><i class="fas fa-angle-down" style="font-size: 0.8em"></i> 4.
                Atlas</a
              >
            </li>
          </ul>
        </div>
        <div class="col-5"></div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col">
          <h2 id="introduction">Introduction</h2>
          <p>
            This is a factsheet containing open data to support sustainable land
            and water management in predominantly arid and semi-arid landscapes.
          </p>
          <p>
            The structure of the report is as follows: initial sections help you
            to understand the landscape better based on open-access datasets,
            the middle part helps to identify hotspots and problem areas in your
            landscape, and the last section offers appropriate pathways to
            improving the sustainability of your landscape.
          </p>
        </div>
      </div>
    </div>
    <LandCover
      v-if="loaded"
      v-bind:location="location"
      v-bind:factsheet="factsheet"
      v-bind:loaded="loaded"
    />

    <WaterResources
      v-if="loaded"
      v-bind:location="location"
      v-bind:factsheet="factsheet"
      v-bind:loaded="loaded"
    />

    <RainwaterHarvesting
      v-if="loaded"
      v-bind:location="location"
      v-bind:factsheet="factsheet"
      v-bind:loaded="loaded"
    />

    <BaselineAtlas
      v-if="loaded"
      v-bind:location="location"
      v-bind:factsheet="factsheet"
      v-bind:loaded="loaded"
    />

    <div class="container" v-if="loaded">
      <div class="row">
        <div class="col-7">
          <!--<h2>References</h2>
                    <p>TODO</p>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import _ from "lodash";

import LandCover from "@/components/factsheet/embassy/LandCover.vue";
import Runoff from "@/components/factsheet/embassy/Runoff.vue";
import Erosion from "@/components/factsheet/embassy/Erosion.vue";
import WaterResources from "@/components/factsheet/embassy/WaterResources.vue";
import RainwaterHarvesting from "@/components/factsheet/embassy/RainwaterHarvesting.vue";
import BaselineAtlas from "@/components/factsheet/ldr/BaselineAtlas.vue";

import omnivore from "@mapbox/leaflet-omnivore";

export default {
  name: "embassy",
  props: ["location", "factsheet", "loaded"],
  components: {
    LandCover,
    Runoff,
    Erosion,
    WaterResources,
    RainwaterHarvesting,
    BaselineAtlas,
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {},
};
</script>

<style>
body {
  color: #666;
}
div.factsheet {
  font-size: 1.5em;
}

div.factsheet h1 {
  font-size: 1.3em;
  font-weight: 600;
  margin-top: 15px;
}

div.factsheet h2 {
  font-size: 1.2em;
  font-weight: 600;
  margin-top: 15px;
}

div.factsheet h3 {
  font-size: 1.05em;
  font-weight: 600;
  margin-top: 15px;
}

div.factsheet p {
  line-height: 1.4em;
}

div.factsheet ul li {
  padding: 7px 0px 7px 0px;
}

div.factsheet table td {
  color: #666;
  line-height: 1.4em;
}

ul.collapsed {
  list-style-type: none;
  margin-left: 0px;
  padding-left: 0px;
  margin-bottom: 5px;
}
ul.collapsed li {
  margin-left: 0px;
}

div.data-availability ul {
  list-style-type: none;
  margin-left: 0px;
  padding-left: 0px;
  margin-bottom: 5px;
}
div.data-availability ul li {
  margin-left: 0px;
}
div.factsheet-status-error {
  margin: 20px 0px;
  padding: 20px 20px 6px 20px;
  font-size: 0.8em;
  border-radius: 0px;
  color: #e50000;
  border: 2px solid #e50000;
  background-color: #fff0f0;
}
div.factsheet-status-ok {
  margin: 20px 0px;
  padding: 20px 20px 6px 20px;
  font-size: 0.8em;
  border-radius: 0px;
  color: #378c07;
  border: 2px solid #15b01a;
  background-color: #e8fae9;
}
div.factsheet-status-notice {
  margin: 20px 0px;
  padding: 20px 20px 6px 20px;
  font-size: 0.8em;
  border-radius: 0px;
  color: #666;
  border: 2px solid #ffd152;
  background-color: #ffffe4;
}
</style>
